import { useEffect, useState } from "react";
import Drawer from 'react-modern-drawer';
import dataLoaderServices from "./DataLoaderServices";
import { CommonUtilities } from "commonUtils";
import Pagination from "components/Common/newPagination";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import DataLoaderEditLoad from "./DataLoaderEditLoad";

export default function DataLoaderInvalid(param: any) {

    console.log(param);
    let [editUploaderData, setEditUploaderData] = useState<any>([]);
    let [editUploaderStatus, setEditUploaderStatus] = useState(false);
    let [deleteUploaderData, setDeleteUploaderData] = useState<any>([]);
    let [deleteUploaderStatus, setDeleteUploaderStatus] = useState(false);
    let [assetvalidationList, setassetvalidationList] = useState<any>([]);
    let [assetvalidationListTemp, setassetvalidationListTemp] = useState<any>([]);

    const onCloseDrawer = () => {
        param.onChangeLoadFile()
    }

    useEffect(() => {

        console.log(param)
        validationList();
    }, [param.open]);

    var pagination = {
        pageNumber: 1,
        pageSize: 10,
    }

    const validationList = () => {
        var type = ""
        assetvalidationList = [];
        setassetvalidationList(assetvalidationList)

        CommonUtilities.APILoadingToast('Loading', 'fail');

        if (param.type === 'Contacts') {
            dataLoaderServices.contactValidationList({ type: param.subType, error: param?.errorName }).then((res: any) => {

                assetvalidationListTemp = res;
                setassetvalidationListTemp(assetvalidationListTemp);

                assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                setassetvalidationList(assetvalidationList);
                setassetvalidationListTemp(assetvalidationListTemp);

                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Contracts') {
            dataLoaderServices.contractValidationList({ type: param.subType, error: param?.errorName }).then((res: any) => {

                assetvalidationListTemp = res;
                setassetvalidationListTemp(assetvalidationListTemp);

                assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                setassetvalidationList(assetvalidationList);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Contract Links') {
            dataLoaderServices.contractLinkValidationList({ error: param?.errorName }).then((res: any) => {

                assetvalidationListTemp = res;
                setassetvalidationListTemp(assetvalidationListTemp);

                assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                setassetvalidationList(assetvalidationList);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Release/Track') {
            dataLoaderServices.metadataValidationList({ type: param.subType, error: param?.errorName }).then((res: any) => {

                assetvalidationListTemp = res;
                setassetvalidationListTemp(assetvalidationListTemp);

                assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                setassetvalidationList(assetvalidationList);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Minimum Set Uploader') {
            if (param.subType == "Tracks") {
                dataLoaderServices.TrackvalidationList({ error: param.errorName }).then((res: any) => {

                    assetvalidationListTemp = res;
                    setassetvalidationListTemp(assetvalidationListTemp);

                    assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                    setassetvalidationList(assetvalidationList);
                    if (res) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                });
            }
            if (param.subType == "Releases") {
                dataLoaderServices.ReleasevalidationList({ error: param.errorName }).then((res: any) => {

                    assetvalidationListTemp = res;
                    setassetvalidationListTemp(assetvalidationListTemp);

                    assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                    setassetvalidationList(assetvalidationList);
                    if (res) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                });
            }
            if (param.subType == "Dealerprice") {
                dataLoaderServices.DealerPricevalidationList({ error: param.errorName }).then((res: any) => {

                    assetvalidationListTemp = res;
                    setassetvalidationListTemp(assetvalidationListTemp);

                    assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                    setassetvalidationList(assetvalidationList);

                    if (res) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                });
            }
            if (param.subType == "releaseTrack") {
                dataLoaderServices.ReleaseTrackvalidationList({ error: param.errorName }).then((res: any) => {

                    assetvalidationListTemp = res;
                    setassetvalidationListTemp(assetvalidationListTemp);

                    assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                    setassetvalidationList(assetvalidationList);
                    if (res) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                });
            }
            if (param.subType == "Songs") {
                dataLoaderServices.TrackvalidationList({ error: param.errorName }).then((res: any) => {

                    assetvalidationListTemp = res;
                    setassetvalidationListTemp(assetvalidationListTemp);

                    assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                    setassetvalidationList(assetvalidationList);
                    if (res) {
                        CommonUtilities.CancelAPILoadingToast();
                    }
                });
            }

        }

        if (param.type === 'Song') {
            dataLoaderServices.SongMetaDataValidationList({ type: param.subType, error: param?.errorName }).then((res: any) => {

                assetvalidationListTemp = res;
                setassetvalidationListTemp(assetvalidationListTemp);

                assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                setassetvalidationList(assetvalidationList);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'CUE') {
            dataLoaderServices.CueValidationList({ type: param.subType, error: param?.errorName }).then((res: any) => {

                assetvalidationListTemp = res;
                setassetvalidationListTemp(assetvalidationListTemp);

                assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                setassetvalidationList(assetvalidationList);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }


        if (param.type === 'Upload Mechanicals') {
            dataLoaderServices.dataLoadmechanicalUploadValidation({ type: param.subType }).then((res: any) => {
                assetvalidationList = res;
                setassetvalidationList(assetvalidationList);

                assetvalidationListTemp = res;
                setassetvalidationListTemp(assetvalidationListTemp);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

        if (param.type === 'Mappings') {
            dataLoaderServices.dataLoadMappingValidation({ type: param.subType }).then((res: any) => {

                assetvalidationListTemp = res;
                setassetvalidationListTemp(assetvalidationListTemp);

                assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                setassetvalidationList(assetvalidationList);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }
        if (param.type === 'Data Transfer') {
            dataLoaderServices.dataLoaddataTransferValidation({ type: param.subType }).then((res: any) => {

                assetvalidationListTemp = res;
                setassetvalidationListTemp(assetvalidationListTemp);

                assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                setassetvalidationList(assetvalidationList);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }
        if (param.type === 'Data Transfer') {
            dataLoaderServices.dataLoaddataTransferValidation({ type: param.subType }).then((res: any) => {

                assetvalidationListTemp = res;
                setassetvalidationListTemp(assetvalidationListTemp);

                assetvalidationList = res.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                setassetvalidationList(assetvalidationList);
                if (res) {
                    CommonUtilities.CancelAPILoadingToast();
                }
            });
        }

    }

    const ExportAllInvalid = () => {

        var payLoad = {
            "Type": param.type,
            "subType": param.subType,
            "error": param.errorName
        }

        var fileName = param.type + '_' + param.subType + '_' + 'Invalid_listing'
        dataLoaderServices.InvalidErrorExport(payLoad, fileName)
    }

    const onPageChange = (e: any) => {
        console.log(e)

        pagination.pageNumber = e.pageNumber;
        pagination.pageSize = e.pageSize;

        assetvalidationList = assetvalidationListTemp.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
        setassetvalidationList(assetvalidationList);
    }

    const editUploader = (uploadData: any) => {
        console.log(uploadData)
        editUploaderStatus = true;
        setEditUploaderStatus(editUploaderStatus)
        editUploaderData = uploadData
        setEditUploaderData(editUploaderData)
        console.log(editUploaderStatus)
    }

    const deleteUploader = (uploadData: any) => {
        console.log(uploadData)
        deleteUploaderData = uploadData;
        setDeleteUploaderData(deleteUploaderData);
        deleteUploaderStatus = true;
        setDeleteUploaderStatus(deleteUploaderStatus);
    }

    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        console.log(deleteUploaderData)
        if (e == 1) {
            uploadDelete();
        }
        //e==2 NO
        editUploaderStatus = false;
        setDeleteUploaderStatus(editUploaderStatus)
    }

    const uploadDelete = () => {

        console.log(deleteUploaderData)
        console.log(deleteUploaderData)
        console.log(deleteUploaderData.contactUploadID)
        if (param.type == 'Contacts') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloaderContactDelete(deleteUploaderData.contactUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Contracts') {
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloadercontractDelete(deleteUploaderData.contractUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Contract Links') {
            console.log(deleteUploaderData.contractLinkUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloadercontractLinkDelete(deleteUploaderData.contractLinkUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Release/Track' && param.subType == 'releaseTrack') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloadermetaDataGenericDelete(deleteUploaderData.contractUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Release/Track' && param.subType == 'Releases') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloaderMetaDataGenericCompilationsDelete(deleteUploaderData.contactUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Release/Track' && param.subType == 'Track') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloaderMetaDataGenericTrackDelete(deleteUploaderData.contactUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'CUE') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloaderCueDelete(deleteUploaderData.contactUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Song') {
            console.log(deleteUploaderData.contactUploadID)
            CommonUtilities.APILoadingToast('Loading', 'fail')

            dataLoaderServices.DataloaderSongMetaDataDelete(deleteUploaderData.contactUploadID).then((res: any) => {
                apiRespondMgt(res, "Delete");
            });
        }

        if (param.type == 'Minimum Set Uploader') {

            if (param.subType == 'Track') {
                console.log(deleteUploaderData.trackUploadId)
                CommonUtilities.APILoadingToast('Loading', 'fail')

                dataLoaderServices.DataloaderMinUploaderTrackDelete(deleteUploaderData.trackUploadId).then((res: any) => {
                    apiRespondMgt(res, "Delete");
                });
            }

            if (param.subType == 'Releases') {
                console.log(deleteUploaderData.releaseUploadId)
                CommonUtilities.APILoadingToast('Loading', 'fail')

                dataLoaderServices.DataloaderMinUploaderReleaseDelete(deleteUploaderData.releaseUploadId).then((res: any) => {
                    apiRespondMgt(res, "Delete");
                });
            }

            if (param.subType == 'Dealerprice') {
                console.log(deleteUploaderData.dealerPriceUploadID)
                CommonUtilities.APILoadingToast('Loading', 'fail')

                dataLoaderServices.DataloaderMinUploaderDealerPriceDelete(deleteUploaderData.dealerPriceUploadID).then((res: any) => {
                    apiRespondMgt(res, "Delete");
                });
            }

            if (param.subType == 'releaseTrack') {
                console.log(deleteUploaderData.releaseTracksUploadId)
                CommonUtilities.APILoadingToast('Loading', 'fail')

                dataLoaderServices.DataloaderMinUploaderReleaseTrackDelete(deleteUploaderData.releaseTracksUploadId).then((res: any) => {
                    apiRespondMgt(res, "Delete");
                });
            }

            if (param.subType == 'Songs') {
                console.log(deleteUploaderData.tempTableMinimumSetSongID)
                CommonUtilities.APILoadingToast('Loading', 'fail')

                dataLoaderServices.DataloaderMinUploaderSongDelete(deleteUploaderData.tempTableMinimumSetSongID).then((res: any) => {
                    apiRespondMgt(res, "Delete");
                });
            }
        }
    }

    const apiRespondMgt = (respond: any, respondFor: any) => {

        if (respond) {
            validationList();
            CommonUtilities.CancelAPILoadingToast();
            CommonUtilities.showToastDawer(respondFor + " Successful", "Success");
        }

        if (!respond) {
            CommonUtilities.CancelAPILoadingToast();
            CommonUtilities.showToastDawer(respondFor + " fail", "fail");
        }
    }

    const onChangeEditLoad = (e: any) => {
        editUploaderStatus = false;
        setEditUploaderStatus(editUploaderStatus)
    }

    return (<>

        <Drawer open={param.open} direction='right' className='react-drawer allowVscroll allowHscroll' size={800}>

            <div className="box noBorderRadius noBorder ws-10 pull-right landing allowVscroll allowHscroll">

                <div className="box-header  noBorderRadius bg-blue pm">{param.errorName} </div>

                <div className="ws-12 pm">
                    <div className="table-responsive allowVscroll allowHscroll">
                        <table className="newTable">
                            <thead>
                                <tr>
                                    {dataLoaderServices.validationListing?.map((viewMap: any) => {
                                        if (viewMap.fieldFor === param.type && !viewMap.for) {
                                            return (
                                                viewMap.fieldName?.map((naming: any) => {
                                                    return (
                                                        <th className='forceSingleLine'>{naming}</th>
                                                    )
                                                })
                                            )
                                        }

                                        if (viewMap.fieldFor === param.type && viewMap.for && viewMap.for === param.subType) {
                                            return (
                                                viewMap.fieldName?.map((naming: any) => {
                                                    return (
                                                        <th className=''>{naming}</th>
                                                    )
                                                })
                                            )
                                        }

                                    })}

                                    {(param?.type != 'Data Transfer' && param?.type != 'Mappings' && param?.type != 'Upload Mechanicals') && <th className='forceSingleLine ws-12'>Operation</th>}
                                </tr>
                            </thead>
                            <tbody>

                                {assetvalidationList?.map((searchValue: any) => {
                                    return (
                                        <tr>
                                            {dataLoaderServices.validationListing.map((value: any, index: any) => {


                                                if (value.fieldFor === param.type && !value.for) {
                                                    return (

                                                        value.fieldCode?.map((valueMap: any) => {
                                                            return (<> <td className='forceSingleLine'>{searchValue[valueMap]}</td>  </>)
                                                        })
                                                    )
                                                }

                                                if (value.fieldFor === param.type && value.for && value.for === param.subType) {
                                                    return (

                                                        value.fieldCode?.map((valueMap: any) => {
                                                            return (<> <td className='forceSingleLine'>{searchValue[valueMap]}</td>  </>)
                                                        })
                                                    )
                                                }

                                            })}

                                            {(param?.type != 'Data Transfer' && param?.type != 'Mappings' && param?.type != 'Upload Mechanicals') &&
                                                <td className='forceSingleLine ws-12'>

                                                    <div style={{ width: "95px" }}>
                                                        <button title="Edit" onClick={() => editUploader(searchValue)} className="icon-btn edit btn-m"><i className="icon-pencil"></i></button>
                                                        <button title="Delete" onClick={() => deleteUploader(searchValue)} className="icon-btn delete btn-m"><i className="icon-trash"></i></button>

                                                    </div>
                                                </td>}
                                        </tr>

                                    )
                                })}
                            </tbody>
                        </table>

                    </div>

                    {(assetvalidationListTemp.length > 10) && <div className="clearfix">
                        <Pagination totalRow={assetvalidationListTemp.length} onPageChange={onPageChange} />
                    </div>}
                </div>

                <div className="ws-12 pm ">
                    <button type="button" className="icon-btn edit pull-right width90 height30" onClick={() => ExportAllInvalid()}>Export</button>
                    <button type="button" className="icon-btn delete pull-right width90 height30" onClick={() => onCloseDrawer()}>Close</button>
                </div>


                {(() => {

                    if (editUploaderStatus && editUploaderData) {
                        return (<DataLoaderEditLoad onChangeEditLoad={onChangeEditLoad} open={editUploaderStatus} type={param.type} subType={param.subType} data={editUploaderData} />)
                    }

                    if (deleteUploaderStatus) {
                        return <DeleteDialogueBox param={deleteUploaderStatus} message={"delete the record"} onChange={deleteConfirmation} />
                    }

                })()}
            </div>

        </Drawer>
    </>)

}